<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <span class="loading-spiner" *ngIf="!location"></span>

    <form [formGroup]="form" class="form-horizontal" autocomplete="off" novalidate *ngIf="location">
      <app-translation-content-title [language]="language"></app-translation-content-title>

      <!-- Name -->
      <div class="form-group">
        <label class="col-md-3 control-label">
          <span class="required">*</span> {{ 'NAME' | translate }}
        </label>
        <div class="col-md-9">
          <input type="text" class="form-control" formControlName="name" maxlength="255" />
          <app-form-errors [control]="form.controls['name']"></app-form-errors>
          <app-form-server-errors [error]="serverErrors['name']"></app-form-server-errors>
        </div>
      </div>

      <!-- Url -->
      <div class="form-group">
        <label class="col-md-3 control-label">
          <span class="required">*</span> {{ 'URL_ADDRESS' | translate }}
        </label>
        <div class="col-md-9">
          <input type="text" class="form-control" formControlName="url" maxlength="255" />
          <app-form-errors [control]="form.controls['url']"></app-form-errors>
          <app-form-server-errors [error]="serverErrors['url']"></app-form-server-errors>
        </div>
      </div>

      <!-- Short description -->
      <div class="form-group">
        <label class="col-md-3 control-label">{{ 'SHORT_DESCRIPTION' | translate }}</label>
        <div class="col-md-9">
          <textarea class="form-control" formControlName="short_description" rows="2"></textarea>
        </div>
      </div>

      <!-- Long description -->
      <div class="form-group">
        <label class="col-md-3 control-label">{{ 'LONG_DESCRIPTION' | translate }}</label>
        <div class="col-md-9">
          <!-- <textarea class="form-control" formControlName="long_description" rows="2"></textarea> -->
          <div class="NgxEditor__Wrapper">
            <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
            <ngx-editor
              [editor]="editor"
              formControlName="long_description"
              [placeholder]="''"
            ></ngx-editor>
          </div>
        </div>
      </div>

      <!-- Highlights -->
      <div class="form-group">
        <label class="col-md-3 control-label">{{ 'HIGHLIGHTS' | translate }}</label>
        <div class="col-md-9">
          <textarea class="form-control" formControlName="highlights" rows="2"></textarea>
        </div>
      </div>

      <div class="form-actions no-wrap">
        <app-item-detail-form-actions
          [disableSaveItem]="sendingForm"
          [updateItemLabel]="'SAVE_CHANGES'"
          [sendingForm]="sendingForm"
          (canceled)="onCanceled()"
          (saved)="onSavedLocationTranslation()"
        ></app-item-detail-form-actions>
      </div>
    </form>
  </div>
</div>
